import React, { useEffect, useState } from "react";
import Footer from "./Include/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "./hero.css";
import ImageGallery from "./ImageGallery/ImageGallery";
import Navbar from "./Include/Navbar";
import { checkAccess } from "./utils/auth";
import Shloks from "./Shloks/Shloks";
function Home({ baseUrl }) {
  const images = [
    "https://ik.imagekit.io/i3giodzh1/images/gemini-2.5-flash-image_a_surreal_and_vibrant_cinematic_photo_of_Ultra-detailed_divine_portrait_of_Lord_-0.jpg?updatedAt=1778303194746",
    "https://ik.imagekit.io/i3giodzh1/images/Ultra_detailed_neon_divine_portrait_202605090310.jpeg",
    "https://ik.imagekit.io/i3giodzh1/images/Create_an_ultra-detailed_divine_portrait_202605070214.jpeg",
    "https://ik.imagekit.io/i3giodzh1/images/Ultra_detailed_ethereal_Lord_Hanuman_202605090351.jpeg",
  ];
  const [slideIndex, setSlideIndex] = useState(0);
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-load');
    elements.forEach((el, index) => {
      el.style.animationDelay = `${0.2 + index * 0.15}s`;
    });
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);


  useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, {
            threshold: 0.1,     // Trigger when 10% visible
            rootMargin: "0px 0px -50px 0px"
        });

        const elements = document.querySelectorAll('.animate-on-scroll');
        elements.forEach(el => observer.observe(el));

        // Cleanup
        return () => {
            elements.forEach(el => observer.unobserve(el));
        };
    }, []);
  return (
    <>
      {/* NAVBAR */}
      <Navbar baseUrl={baseUrl} />
      {/* HERO */}
      <section className="hero">
        <div className="hero-container">
          {/* LEFT IMAGE */}
          <div className="hero-left animate-on-load"></div>
          {/* CENTER CONTENT */}
          <div className="hero-content">
            <span className="hero-badge animate-on-load">
              ✨ Your Daily Spiritual Companion
            </span>
            {/*  <h1>
              Bringing <span>Sanatan</span><br />
              <span>Wisdom</span> to Every Heart
            </h1> */}
            <h1 className="animate-on-load" style={{ animationDelay: '0.5s' }}>
              Bringing <span>Sanatan</span><br />
              <span className="wisdom">Wisdom</span> to Every Heart
            </h1>
            <p className="animate-on-load" style={{ animationDelay: '0.8s' }}>
              Experience bhajans, mantras, devotional music,
              wallpapers, sacred books, daily quotes and
              spiritual positivity in one beautiful mobile experience.
            </p>
            {/* <div className="hero-buttons">
              <a href="#" className="btn-primary-custom">
                ↓ Download App
              </a>
              <a href="#" className="btn-outline-custom">
                Explore Features →
              </a>
            </div>
            <div className="hero-stats">
              <div>
                <h3>50K+</h3>
                <span>Downloads</span>
              </div>
              <div>
                <h3>4.9★</h3>
                <span>Ratings</span>
              </div>
              <div>
                <h3>24/7</h3>
                <span>Spiritual Access</span>
              </div>
            </div> */}
          </div>
          {/* PHONE MOCKUP */}
          <div className="hero-phone animate-on-load" style={{ animationDelay: '1.1s' }}>
            <div className="custom-slide">
              <img
                src={images[slideIndex]}
                alt="Dharmiq App Preview"
              />
            </div>
            <div className="dots">
              {images.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === slideIndex ? "active" : ""}`}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* Image Gallery */}
      <ImageGallery baseUrl={baseUrl} />
      {/* Shloks */}
      <Shloks baseUrl={baseUrl}/>
      {/* FEATURES */}
      <section className="section animate-on-scroll">
        <div className="custom-container">
          <div className="section-title text-center">
            <h2 className="animate-on-load" style={{ animationDelay: '0.3s' }}>App Features</h2>
            <p className="animate-on-load" style={{ animationDelay: '0.5s' }}>
              Everything you need for your spiritual journey
            </p>
          </div>
          <div className="row g-4">
            <div className="col-md-6 col-lg-3">
              <div className="feature-card h-100">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/3659/3659899.png"
                  alt=""
                />
                <h3 className="animate-on-load" style={{ animationDelay: '0.7s' }}>Daily Status</h3>
                <p>
                  Share inspiring devotional status and quotes
                  every day.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="feature-card h-100">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1048/1048953.png"
                  alt=""
                />
                <h3>Bhajans & Aarti</h3>
                <p>
                  Listen to soulful bhajans and aarti collections
                  anytime.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="feature-card h-100">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/2840/2840053.png"
                  alt=""
                />
                <h3>Mantra Chanting</h3>
                <p>
                  Chant sacred mantras with meditation and
                  counting support.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="feature-card h-100">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/2436/2436874.png"
                  alt=""
                />
                <h3>Religious Books</h3>
                <p>
                  Read scriptures, chalisa, kavach, and spiritual
                  stories.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* APP SECTION */}
      <section className="section animate-on-scroll">
        <div className="custom-container">
          <div className="app-section">
            <div>
              <h2>Feel Peace Everyday</h2>
              <p>
                Explore divine content with a clean and modern
                user experience. Get access to wallpapers, daily
                horoscope, mantras, devotional songs, and much
                more.
              </p>
              {/* <a href="#" className="btn-light-custom">
                Get Started
              </a> */}
            </div>
            <div>
              <img
                src="https://ik.imagekit.io/i3giodzh1/images/feel_peace.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      {/* TESTIMONIALS */}
      <section className="section animate-on-scroll">
        <div className="custom-container">
          <div className="section-title text-center">
            <h2>User Reviews</h2>
            <p>
              Loved by spiritual seekers around the world
            </p>
          </div>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="testimonial h-100">
                <img
                  src="https://imgs.search.brave.com/cAlyGM-nmq1YbAiUCzVmyj1bjEBpty3kMqNDq8Dvgf8/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pMC53/cC5jb20vd3d3LnBu/Z2tpdC5jb20vcG5n/L2Z1bGwvMzAyLTMw/MjIyMTdfcm9nZXIt/YmVycnktYXZhdGFy/LXBsYWNlaG9sZGVy/LnBuZw"
                  alt=""
                />
                <p>
                  This app gives peaceful vibes and amazing
                  devotional music. Very clean interface and easy
                  to use.
                </p>
                <h4>Priya Sharma</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="testimonial h-100">
                <img
                  src="https://imgs.search.brave.com/cAlyGM-nmq1YbAiUCzVmyj1bjEBpty3kMqNDq8Dvgf8/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pMC53/cC5jb20vd3d3LnBu/Z2tpdC5jb20vcG5n/L2Z1bGwvMzAyLTMw/MjIyMTdfcm9nZXIt/YmVycnktYXZhdGFy/LXBsYWNlaG9sZGVy/LnBuZw"
                  alt=""
                />
                <p>
                  Best spiritual application for daily mantra and
                  bhajan listening. Highly recommended.
                </p>
                <h4>Rahul Verma</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="testimonial h-100">
                <img
                  src="https://imgs.search.brave.com/cAlyGM-nmq1YbAiUCzVmyj1bjEBpty3kMqNDq8Dvgf8/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pMC53/cC5jb20vd3d3LnBu/Z2tpdC5jb20vcG5n/L2Z1bGwvMzAyLTMw/MjIyMTdfcm9nZXIt/YmVycnktYXZhdGFy/LXBsYWNlaG9sZGVy/LnBuZw"
                  alt=""
                />
                <p>
                  Beautiful UI with devotional content and
                  positive energy. I use it every morning.
                </p>
                <h4>Anjali Patel</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* FOOTER */}
      <Footer baseUrl={baseUrl} />
    </>
  );
}
export default Home;